<admin-header [title]="title"></admin-header>
<div class="row" *ngFor="let group of tilesGrouped" style="padding-top:10px">
	<h2 *ngIf="title === 'Administration Menu' && group[0].category !== 'Administration'" style="padding-left:30px; color:#344281">{{group[0].category}}</h2>
	<!-- <div *ngFor="let tile of tiles" class="col-12 col-sm-6 col-sm-3 col-lg-2 col-xl-2 col-xxl-2 col-xxxl-1">		
		<div class="admin-tile">
			<div class="tile position-relative pointer" (click)="navigate(tile.route)">
				<i class="fal {{tile.icon}} position-absolute start-50 translate-middle fs-30"></i>
				<span class="position-absolute start-50 translate-middle-x text-center">{{tile.text}}</span>
			</div>
		</div>
	</div> -->
	<div class="card-grid">
  <div class="dashboard-card" *ngFor="let card of group" (click)="navigate(card.route)">
    <div class="icon-wrapper">
      <i [class]="card.icon"></i>
    </div>
    <div class="card-title">{{ card.text }}</div>
  </div>
</div>
</div>